import {
  AccordionSummary as MuiAccordionSummary,
  AccordionSummaryProps as MuiAccordionSummaryProps,
  accordionSummaryClasses,
} from '@mui/material'
import styled from 'styled-components'

export type AccordionSummaryPropsType = MuiAccordionSummaryProps

const AccordionSummary = styled(MuiAccordionSummary)<AccordionSummaryPropsType>``

export { accordionSummaryClasses }

export default AccordionSummary
